import axios from 'axios';
import moment from 'moment';
import React, { useEffect, useMemo, useRef, useState, useCallback } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import Select from 'react-select';
import Swal from 'sweetalert2';
import SkeletonTicketList from '../../../../loaders/SkeletonTicketList';
import { GetMarkingAssessmentAllQuestions, GetMarkingAssessmentQuestion, GetMarkingAssessmentStudentList, updateAssessmentScore, updateObservation } from '../../../../services/CourseService';
import PermissionsGate from "../../../../utils/permissionGate";
import { sortUtils, twoDecimalRound } from '../../../../utils/commonFunction';
import { AssessmentMarkingMarkedFilter, RenderQuestionLevel, RenderQuestionType, RenderSubmissionStatus } from '../../../../utils/CommonGroupingItem';
import { IMAGE_URL } from '../../../../utils/Constants';
import DataTableComponentFrontPagination from '../../../common/DataTableComponentFrontPagination';
import { InitialRender, isBlockedNumericKey } from '../../../common/Helper';
import Hover from '../../../common/Hover';
import { ColorRender } from '../../../systemadministration/usermanagement/CheckRole';
import SubmissionModal from './SubmissionModal';
import ExpandableText from './ExpandableText';
import $ from "jquery"
import RenderOption from '../../smartAssessment/questionBank/RenderOption';
import HtmlParser from 'react-html-parser';
import DownloadModalComponent from './DownloadModalComponent';
import { createCleanFilePath } from '../../../../utils/FileDownload';

const evidenceOptions = [
    { key: "evidence_photo", name: "Photo", icon: "camera" },
    { key: "evidence_video", name: "Video", icon: "video" },
    { key: "evidence_lecturer_observation", name: "Lecturer Observation", icon: "user-check" },
];

const AssessmentQuizTestMarking = ({ assessmentHeader }) => {
    const [tableState, setTableState] = useState({
        page: 1,
        perPage: 10,
        sortKey: "studentName",
        sortOrder: "asc",
    });


    const [expanded, setExpanded] = useState({
        questionExpand: false,
        questionAnswerExpand: false
    });
    const [showSeeMore, setShowSeeMore] = useState({
        questionExpandSeeMore: false,
        questionAnswerExpandSeeMore: false
    });
    const descriptionRef = useRef(null);
    const answersRef = useRef(null);
    const [search, setSearch] = useState("");
    const [status, setStatus] = useState({ arr: [], checkObj: {} });
    const [marked, setMarked] = useState({ arr: [], checkObj: {} });
    const [questionDetailsLoading, setQuestionDetailsLoading] = useState(true);
    const [questionLoading, setQuestionLoading] = useState(true);
    const [dontShowLoading, setDontShowLoading] = useState(false);
    const [dontShowDetailsLoading, setDontShowDetailsLoading] = useState(false);
    const [allQuestionList, setAllQuestionList] = useState([]);
    const [allStudentList, setAllStudentList] = useState([]);
    const [selectedStudentDetails, setSelectedStudentDetails] = useState({});
    const searchParams = new URLSearchParams(window.location.search);
    const questionId = searchParams.get('questionId');
    const {id, subId } = useParams();
    const [questionData, setQuestionData] = useState({});
    const [errorMessage, setErrorMessage] = useState("You can't put score more then question score");
    const [refreshStudentList, setRefreshStudentList] = useState(false);
    const [refreshQuestiionData, setRefreshQuestiionData] = useState(false);
    const [matrixData, setMatrixData] = useState([]);
    const downloadRef = useRef(null);
    const [studentScore , setStudentScore] = useState([]);
    const [assDetails, setAssDetails] = useState([]);
    const [assessmentName, setAssessmentName] = useState("");
    const [isLoadingObservationId, setIsLoadingObservationId] = useState({});

    const groupedQuestions = useMemo(() => {
        allStudentList.sort((a, b) => a.studentName.localeCompare(b.studentName));

        // Add styling to questions
        const styledQuestions = allStudentList.map(question => ({
            ...question,
            className: (question.is_marked || !isMatchingQuestionType(["Document upload", "Long Answer", "Evidence Only"])) ? 'white-bg' : 'red-gradian-bg'
        }));
        return styledQuestions

    });

    const history = useHistory()
    const location = useLocation();

    useEffect(() => {
        const checkOverflow = () => {
            const questionOverflow = descriptionRef.current
                ? descriptionRef.current.scrollHeight > descriptionRef.current.clientHeight
                : false;

            const answerOverflow = answersRef.current
                ? answersRef.current.scrollHeight > answersRef.current.clientHeight
                : false;

            setShowSeeMore((prev) => ({
                ...prev,
                questionExpandSeeMore: questionOverflow,
                questionAnswerExpandSeeMore: answerOverflow,
            }));
        };
        setTimeout(() => {
            checkOverflow();
        }, 1000);
        window.addEventListener('resize', checkOverflow);

        return () => {
            window.removeEventListener('resize', checkOverflow);
        };
    }, [questionData]);

    // Reset expanded state when questionId changes
    useEffect(() => {
        setExpanded({
            questionExpand: false,
            questionAnswerExpand: false
        });
    }, [questionId]);

    const fetchAllQuestions = async (source) => {
        try {
            const res = await GetMarkingAssessmentAllQuestions(subId, id, source.token);
            const data = res?.data?.data?.map((item) => ({ label: item?.label, value: item?.value }))
            setAllQuestionList(data)
        } catch (error) {
            if (!axios.isCancel(error)) {
                console.error(error);
            }
        }
    };

    const fetchQuestionData = async (source) => {
        try {
            if (!dontShowDetailsLoading) {
                setQuestionDetailsLoading(true)
            }
            const body = {
                assessmentId: subId,
                quesId: questionId,
                intake: id
            }
            const res = await GetMarkingAssessmentQuestion(body, source.token);
            setQuestionData(res?.data?.data)

        } catch (error) {
            if (!axios.isCancel(error)) {
                console.error(error);
            }
        } finally {
            setDontShowDetailsLoading(false)
            setQuestionDetailsLoading(false)
        }
    };

    const fetchMarkingStudentList = async (source) => {
        try {
            if (!dontShowLoading) {
                setQuestionLoading(true)
            } 
            const body = {
                assessmentId: subId,
                quesId: questionId,
                intake: id
            }
            const res = await GetMarkingAssessmentStudentList(body, source)
            setAllStudentList(res.data?.data)
            setAssDetails(res.data?.getAssessmentDetails)
            setAssessmentName(res.data?.getAssessmentDetails?.name)
            setQuestionLoading(false);
            if(dontShowLoading){
                setStudentScore((prev) =>
                    prev.map((item) => {
                      const student = res.data?.data?.find((s) => s?.id == item?.id);
                      const sameScore = student?.score == (item?.score || 0);
                      return {
                        ...item,
                        score:  (student?.is_marked && item?.score) ? twoDecimalRound(item?.score) : "", 
                        loading: sameScore ? false : item.loading
                      };
                    })
                  );
                  
            }else{
              const temp = res.data?.data?.map((item) => {
                return {
                    id : item?.id , 
                    score : item?.score,
                    error : false,
                    loading : false
                  }
              })
              setStudentScore(temp)
            }
        } catch (error) {
            if (!axios.isCancel(error)) {
                console.error(error);
            }
            setQuestionLoading(false);
            setAllStudentList([])
            setStudentScore((prev) =>
                prev.map((item) => ({
                  ...item,
                  loading: false
                }))
              );
              
        }
    }

    useEffect(() => {
        const questionSource = axios.CancelToken.source();
        if (questionId && subId) {
            fetchQuestionData(questionSource);
        }

        return () => {
            questionSource.cancel();
        };
    }, [questionId, subId, refreshQuestiionData]);


    useEffect(() => {
        const studentSource = axios.CancelToken.source();
        if (questionId && subId) {
            fetchMarkingStudentList(studentSource);
        }
        return () => {
            studentSource.cancel();
        };
    }, [questionId, subId, refreshStudentList]);


    useEffect(() => {
        const allQuestionSource = axios.CancelToken.source();
        if (subId) {
            fetchAllQuestions(allQuestionSource);
        }

        return () => {
            allQuestionSource.cancel();
        };
    }, [subId]);

    const assessmentDetails = useMemo(() => [
        {
            title: "Type",
            tooltip: "Type",
            value: [{
                render: RenderQuestionType(questionData?.question_type).html,
                tooltip: questionData?.question_type
            }],


        },
        ...(isMatchingQuestionType(["Evidence Only", "Document Upload", "Long Answer"]) ? [{
            title: "Evidence",
            tooltip: "Evidence",
            value: [
                questionData?.evidence_photo ? evidenceOptions[0] : null,
                questionData?.evidence_video ? evidenceOptions[1] : null,
                questionData?.evidence_lecturer_observation ? evidenceOptions[2] : null,
            ].filter(Boolean)
        }] : []),
        {
            title: "Score",
            tooltip: "Score",
            value: [{
                name: questionData?.correct_score ? twoDecimalRound(questionData?.correct_score) : "-",
                tooltip: questionData?.correct_score ? twoDecimalRound(questionData?.correct_score) : "-"
            }],

        },
        {
            title: "Level",
            tooltip: "Level",
            value: [{
                render: RenderQuestionLevel(questionData?.level_name).html,
                tooltip: questionData?.level_name
            }],
        },
        {
            title: "Submitted",
            tooltip: "Submitted",
            value: [{
                name: questionData?.submission_status,
                tooltip: questionData?.submission_status
            }],
        },
        {
            title: "Marked",
            tooltip: "Marked",
            value: [{
                name: questionData?.mark_status,
                tooltip: questionData?.mark_status
            }],

        },
        {
            title: "Component",
            tooltip: "Component",
            value: [{
                name: questionData?.component_code ? questionData?.component_code : "-",
                tooltip: questionData?.component_code ? questionData?.component_code : "-"
            }],

        },
    ]);


    const handleScoreUpdateCallback = useCallback((e, rowId, maxValue, item) => {
        if(!isMatchingQuestionType(["Document upload", "Long Answer", "Evidence Only"])) {
            return 
        }
        let value = e.target.value ? Number(e.target.value) : "a";

        if (parseFloat(value) > parseFloat(maxValue)) {
            setStudentScore((prev) =>
                prev.map((item) => {
                const idMatched = rowId == item?.id
                  return {
                    ...item,
                    score : idMatched ? e.target.value : item.score,
                    loading: idMatched ? false : item.loading,
                    error : idMatched ? true : item.error 
                  };
                })
              );
            return;
        } else {
            setStudentScore((prev) =>
                prev.map((item) => {
                const idMatched = rowId == item?.id
                  return {
                    ...item,
                    score : idMatched ? e.target.value : item.score,
                    loading: idMatched ? true : item.loading,
                    error : idMatched ? false : item.error 
                  };
                })
              );
        }
        const payload = {
            qid: questionId,
            score: value,
            updated_qid: item?.id,
            rid: item?.rid,
            tab: "Marked Question Student"
        }
        updateAssessmentScore(payload).then((res) => {
            setDontShowLoading(true)
            setDontShowDetailsLoading(true)
            setRefreshStudentList(!refreshStudentList)
            setRefreshQuestiionData(!refreshQuestiionData)
        }).catch((err) => {
            setStudentScore((prev) =>
                prev.map((item) => ({
                  ...item,
                  loading: false
                }))
              );
              
            Swal.fire({
                icon: "error",
                title: "Error",
                text: `${err?.response?.data?.data}`,
            });
        })
    });

   
    const handleDownload = (studentId, fileName,evidence_type) =>{
        let payload = {
            assignmentId : subId,
            qid : questionId,
            intake : id
        }
        if(studentId){
            payload.student_id = studentId
        }
        if(evidence_type){
            payload.evidence_type = evidence_type?.toLowerCase() == "photo" ? 0 : 1 
        }
        return payload
    }

    function isMatchingQuestionType(allowedTypes = []) {
        if (!questionData?.question_type) return false;
        const type = questionData.question_type.toLowerCase();
        return allowedTypes.map(t => t.toLowerCase()).includes(type);
    }

    useEffect(() => {
        if (isMatchingQuestionType(['Choice Matrix'])) {
            let tempArr = []
            let arr = questionData?.questionsOptions?.map((item, i) => {
                let tempObj = {
                    titleValue: item.titleValue,
                    optionid: item.oid,
                    rowTitle: <input type="text"
                        className={"form-control"}
                        name="item"
                        placeholder="Row"
                        title="Row"
                        defaultValue={item.titleValue}
                    />,
                    options: item?.q_option ?
                        JSON.parse(item?.q_option).length ?
                            JSON.parse(item?.q_option).map((ele, j) => {
                                return {
                                    ...ele,
                                    text: <input type="text"
                                        className={"form-control"}
                                        name="item"
                                        placeholder="Column"
                                        title="Column"
                                        defaultValue={ele?.titleValue}
                                        value={matrixData[i]?.options[j].titleValue}
                                    />
                                }
                            }) :
                            [] :
                        []
                }
                tempArr.push(tempObj);
            })
            setMatrixData(tempArr)
        }
    }, [questionData])

    const EvidenceItem = ({ item, type, hasEvidence, toShow, modalId }) => {
        const evidenceUrl = ''
        const icon = type === 0 ? 'fa-camera' : 'fa-video';
        const label = type === 0 ? 'Photo' : 'Video';

        return (
            toShow && (<div className="evidence-wrp" title={`${label}`}>
                <i className={`fas ${hasEvidence ? 'fa-check-circle cat-greenhex' : 'fa-times-circle colorRed'}`} />
                <i className={`fal ${icon}`} />
                <p>{label}</p>
                {hasEvidence && (
                    <>
                    <DownloadModalComponent children={
                        <a
                            className="download_btn"
                            data-toggle="modal" 
                            data-target={`#s${modalId}`}
                            aria-label={`Download ${label}`}
                        >
                            <i className="fal fa-download" />
                        </a>
                    } modalId={"s"+modalId} downloadRef={downloadRef} zipName={`evidence_${label?.toLowerCase()}_${item?.studentName}`} payload={handleDownload(item?.uid,  `evidence_${label?.toLowerCase()}_${item?.studentName}`,label)} type={'downloadSubmission'}/>
                    </>
                )}


            </div>)
        );
    };

    const groupEvidence = (item) => {
        const groupedEvidence = (item?.studentEvidence || []).reduce((acc, evidence) => {
            const type = evidence.evidence_type;
            if (type === 0 || type === 1) {
                acc[type] = [...(acc[type] || []), evidence];
            }
            return acc;
        }, {});
        return [0, 1].map((type, id) => (
            <EvidenceItem key={id} type={type} hasEvidence={groupedEvidence[type]?.length > 0 ? true : false} item={item} toShow={(item.evidence_photo == 1 && type == 0) || (item.evidence_video == 1 && type == 1)} modalId={item.id+"_"+type}/>
        ));
    };

    useEffect(() => {
        const applyRowStyles = () => {
            const rows = document.querySelectorAll('.rdt_TableRow');
            rows.forEach((row, index) => {
                if (!groupedQuestions[index]?.isGroupHeader) {
                    row.className = `rdt_TableRow ${groupedQuestions[index]?.className || ''}`;
                }
            });
        };

        const timer = setTimeout(applyRowStyles, 100);

        return () => clearTimeout(timer);
    }, [groupedQuestions]);

    const handleObserverToggleCallback = useCallback(async (checked, id) => {
        try {
            setIsLoadingObservationId(prev => ({
                ...prev,
                [id]: true
            }));
            const payload = {
                is_observation: checked ? 1 : 0,
                id: id,
                tab: "Marked Question Student"
            }

            const res = await updateObservation(payload)

            setRefreshStudentList(!refreshStudentList)
            Swal.fire({
                icon: 'success',
                title: res?.data?.message,
            });

        } catch (error) {
            console.error("Error while updating toggle", error)
            Swal.fire({
                icon: "error",
                title: "Error while updating toggle",
                text: error?.message || "Something went wrong",
            });
        } finally {
            setIsLoadingObservationId(prev => ({
            ...prev,
            [id]: false
        }));
        }
    });

    const getMarkedSortValue = (row) => {
        return (row.is_marked ||
          !isMatchingQuestionType(["Document upload", "Long Answer", "Evidence Only"]))
          ? 1
          : 0;
      };

    const columns = useMemo(() => [
        {
            name: "Student",
            selector: "studentName",
            sortField: "studentName",
            sortFunction: sortUtils.stringSort("studentName"),
            sortable: true,
            cell: (row, index) => (
                <div className="assigned-title-block-new">
                    <div className="assigned-title-itm">
                        <span
                            className={
                                'assigned-title-blk  name-icon cat-dark-red ' +
                                ColorRender('student support')
                            }
                        >
                            {row?.picture_me ? (
                                <img
                                    src={`${IMAGE_URL}/${createCleanFilePath(row?.picture_me)}`}
                                    alt="AIE"
                                />
                            ) : (
                                InitialRender([row.first_name, row.last_name])
                            )}
                            <span
                                className={`profile-box-2-status ${row?.activity_status
                                    ? row?.activity_status?.toLowerCase() ==
                                        "online"
                                        ? "Online"
                                        : row?.activity_status?.toLowerCase() ==
                                            "away"
                                            ? "Away"
                                            : "Offline"
                                    : "Offline"
                                    }`}
                            >
                                <i className="fas fa-circle"></i>
                            </span>
                            <Hover
                                fullName={row?.studentName}
                                firstName={row.first_name}
                                lastName={row?.last_name}
                                photo={row?.picture_me}
                                email={row?.Email}
                                mobile={row?.Mobile}
                                right={true}
                                role={'student support'}
                                status={row?.studentStatus}
                                activity_status={row?.activity_status}
                                showNumber={true}
                                number={row?.student_crm_id}
                            />
                        </span>
                        <p>
                            <span
                                className="as-text-blue curser feature-name"
                                key={index}
                                onClick={() =>{
                                    $("#assessment-submission-modal").modal("show");
                                    setSelectedStudentDetails(row)
                                }}
                            >
                                <span
                                    className="textLimit100"
                                    title={`${row.studentName} `}
                                >
                                    {' '}
                                    {`${row.studentName} `}
                                </span>
                            </span>
                        </p>
                    </div>
                </div>
            ),
        },
        {
            name: "Status",
            selector: "status",
            sortField: "status",
            sortable: true,
            sortFunction: (rowA, rowB) => {
                const a = (RenderSubmissionStatus(rowA.status).text || "").toLowerCase();
                const b = (RenderSubmissionStatus(rowB.status).text || "").toLowerCase();
                return a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" });
              },
            cell: (row) => row.status ? RenderSubmissionStatus(row.status).html : "-"
        },
        ...(!isMatchingQuestionType(["Evidence Only",]) ? [
            {
                name: "Submission",
                selector: "Submission",
                cell: (row) => (
                    <>
                        {isMatchingQuestionType(["Document Upload"]) && row?.answerdDocument?.length > 0 && (
                            <DownloadModalComponent children={
                            <div 
                                className='text-primary download-submission-btn'
                                title='Download Submission'
                                data-toggle="modal"
                                data-target="#downloadSubmission"
                            >
                                Download Submission <i className='fal fa-download'></i></div>
                            } modalId={'downloadSubmission'} type={'downloadSubmission'} downloadRef={downloadRef} payload={handleDownload(row?.uid, `${row?.first_name} ${row?.last_name}_${assessmentName}`)} zipName={`${row?.first_name} ${row?.last_name}_${assessmentName}`}/>
                        )}
                        {isMatchingQuestionType(["Long Answer"]) && row?.UserAnswer?.length > 0 && (
                            <>
                                <div className='text-primary download-submission-btn' title='Submitted Answer'>Submitted Answer </div>
                                <p className='user-answer'>
                                    <ExpandableText maxWidth={400} text={row?.UserAnswer} />
                                </p>
                            </>
                        )}
                        {isMatchingQuestionType(["Choice Matrix"]) && row?.UserAnswer?.length > 0 ? (
                            <>
                                <div className='text-primary download-submission-btn' title='Submitted Answer'>Submitted Answer </div>
                                <p className='user-answer'>
                                    <ExpandableText maxWidth={400} text={row?.UserAnswer} />
                                </p>
                            </>
                        ) : null}
                        {!isMatchingQuestionType(["Document upload", "Long Answer", "Evidence Only", "Choice Matrix"]) && row?.UserAnswer && (
                            <>
                                <div className='text-primary download-submission-btn' title='Submitted Answer'>Submitted Answer </div>
                                <p className='user-answer'>
                                    <ExpandableText maxWidth={400} text={row?.UserAnswer} />
                                </p>
                            </>
                        )}
                    </>
                )
            },
        ] : []),
        ...(!isMatchingQuestionType(["Document upload", "Long Answer", "Evidence Only"]) ? [
            {
                name: "",
                selector: "",
                cell: (row) => (
                    row?.correctAnswer?.length > 0 ?
                        <>
                            <div className='text-primary download-submission-btn' title='Correct Answer'>Correct Answer</div>
                            <p className='user-answer'>
                                <ExpandableText maxWidth={400} text={row?.correctAnswer} />
                            </p>
                        </>
                        : null
                )
            },
        ] : []),
        ...(isMatchingQuestionType(["Document Upload", "Long Answer", "Evidence Only"]) ? [
            {
                name: "Evidence",
                selector: "Evidence",
                cell: (row) => (
                    <div className='evidence-con'>
                        <div className='evidence-con'>
                            {groupEvidence(row || [])}
                            {row?.evidence_lecturer_observation == 1 && (
                                <div>

                                    <div className='evidence-wrp' title="Lecturer Observation">
                                        {row?.is_observation == 1 ? <i className="fas fa-check-circle cat-greenhex"></i> : <i className='fas fa-times-circle colorRed'></i>}
                                        <i className="fal fa-user-check" />
                                        <p>Lecturer Observation</p>
                                        <div>
                                            <label className="switch ml-0">
                                                <PermissionsGate scopes={assessmentHeader?.isHybrid ? ["cassgradeassedit"] : ["overidersmart"]} errorProps={{ disabled: true }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={row?.is_observation}
                                                        onChange={(e) => {
                                                            handleObserverToggleCallback(e.target.checked, row.id)
                                                        }}
                                                        disabled={row.lock_grades || isLoadingObservationId[row.id]}
                                                    />
                                                </PermissionsGate>
                                                <span className="slider slider-round"></span>
                                            </label>
                                        </div>
                                    </div>
                                    {
                                        row?.observationBy &&
                                        <div className="evidence-wrp">
                                            {row?.is_observation == 1 && (
                                                <div title={`Confirmed on ${moment.unix(row?.observation_date).format('DD MMM YY [at] HH:mm')} by ${row?.observationBy?.fullname}`}>
                                                    <i className="fal fa-history historyBtn" />
                                                    <span className='ml-2'>Confirmed on <strong className='observer-desc'> {moment.unix(row?.observation_date).format('DD MMM YY [at] HH:mm')}</strong> by <strong className='observer-desc'>{row?.observationBy?.fullname}</strong></span>
                                                </div>
                                            )}
                                        </div>
                                    }
                                </div>
                            )}
                        </div>


                    </div>
                )
            }] : []),
        {
            name: "Result",
            selector: "Result",
            cell: (row) => (
                <div className="input-submission-col resultstatus_flex arrowhide">
                <PermissionsGate scopes={assessmentHeader?.isHybrid ? ["cassgradeassedit"] : ["overidersmart"]} errorProps={{ disabled: true }}>
                    <input
                        className={"form-control" + (studentScore?.find((s) => s.id == row?.id)?.error ? " is-invalid" : "")}
                        type="number"
                        max={row.total_score}
                        onKeyDown={(e) => {
                            // Block +, -, and other non-numeric keys (allow numbers, decimal, backspace, delete, arrows)
                            if (isBlockedNumericKey(e.key)) e.preventDefault();
                        }}
                        value={ (row?.is_marked || !isMatchingQuestionType(["Document Upload", "Long Answer", "Evidence Only"])) ? twoDecimalRound(studentScore?.find((s) => s.id == row?.id)?.score) : "" }
                        onBlur={(e) => handleScoreUpdateCallback(e, row.id, row.total_score, row)}
                        disabled={!isMatchingQuestionType(["Document upload", "Long Answer", "Evidence Only"]) || row.lock_grades == 1}
                    />
                </PermissionsGate>
                    <span>{"/" + row.total_score}</span>
                    {studentScore?.find((s) => s.id == row?.id)?.loading ? <i className="fas fa-cog fa-spin"></i> : ""}
                </div>
            )
        },
        {
            name: "Marked",
            selector: "is_marked",
            sortField: "is_marked",
            sortable: true,
            sortFunction: (rowA, rowB) => {
                const a = getMarkedSortValue(rowA);
                const b = getMarkedSortValue(rowB);
            
                return a - b; // number sorting
              },
            cell: (row) => <p title={row.is_marked || !isMatchingQuestionType(["Document upload", "Long Answer", "Evidence Only"]) ? "MARKED" : "NOT MARKED"}><span className={row.is_marked || !isMatchingQuestionType(["Document upload", "Long Answer", "Evidence Only"]) ? "as-green-bg as-widget" : "as-red-bg as-widget"}>{(row.is_marked || !isMatchingQuestionType(["Document upload", "Long Answer", "Evidence Only"])) ? "MARKED" : "NOT MARKED"}</span></p>

        },
        {
            name: "Actions",
            selector: "",
            cell: (row) => row.isGroupHeader ? null : (
                <div className="assessment-08 btn-dropdown-grp">
                    <div className="as-buttons">
                        <div
                            className="btn btn-primary rounded-circle cursor-pointer"
                            data-toggle="modal"
                            data-target="#assessment-submission-modal"
                            title="Open"
                            onClick={() => {
                                $("#assessment-submission-modal").modal("show");
                                setSelectedStudentDetails(row)
                            }}
                        >
                            <i className="fal fa-folder-open"></i>
                        </div>
                    </div>
                </div>
            )
        }
    ]);

    const goToQuestionList = () => {
        const params = new URLSearchParams(location.search);
        params.delete('questionId');

        const newSearch = params.toString();
        history.push(`${location.pathname}${newSearch ? `?${newSearch}` : ''}`);

    }

    const goToNextQuestion = () => {
        const currentIndex = allQuestionList?.findIndex(q => q.value == questionId);

        if (currentIndex === -1 || currentIndex === allQuestionList.length - 1) {
            return;
        }

        setQuestionLoading(true);
        setQuestionData({})
        setAllStudentList([])
        setStudentScore([])
        setDontShowLoading(false)
        setDontShowDetailsLoading(false)
        const nextQuestionId = allQuestionList[currentIndex + 1].value;
        const params = new URLSearchParams(location.search);
        params.set('questionId', nextQuestionId);

        history.push(`${location.pathname}?${params.toString()}`);
    };

    const goToPreviousQuestion = () => {
        const currentIndex = allQuestionList.findIndex(q => q.value == questionId);
        if (currentIndex <= 0) {
            return;
        }
        setQuestionLoading(true);
        setQuestionData({})
        setAllStudentList([])
        setStudentScore([])
        setDontShowLoading(false)
        setDontShowDetailsLoading(false)
        const previousQuestionId = allQuestionList[currentIndex - 1].value;

        const params = new URLSearchParams(location.search);
        params.set('questionId', previousQuestionId);

        history.push(`${location.pathname}?${params.toString()}`);
    };

    const dataToRender = useMemo(() => {
        let updatedData = allStudentList || [];

        // Handle Search
        if (search.length) {
            updatedData = updatedData.filter((item) =>
                item?.studentName?.toLowerCase().includes(search.toLowerCase())
            );
        }

        // Handle Status Filter
        if (status.arr.length) {
            const statusSet = new Set(status.arr.map((s) => s.toLowerCase()));
            updatedData = updatedData.filter(
                (item) => item.status && statusSet.has(item.status.toLowerCase())
            );
        }

        // Handle Marked Filter
        if (marked.arr.length) {
            const markedSet = new Set(marked.arr);
            updatedData = updatedData.filter(
                (item) => {

                    if (!isMatchingQuestionType(["Evidence Only", "Long Answer", "Document Upload"])) {
                        return item.is_marked !== undefined && markedSet.has('1') && item
                    } else {
                        return item.is_marked !== undefined && markedSet.has(String(item.is_marked))
                    }
                }
            );
        }

        return updatedData;
    });

    const exportDataCallback = useCallback(() => {
        let data = dataToRender;

        data.sort((a, b) => a.studentName.localeCompare(b.studentName))

        let header = [
            'Student',
            'Status',
            'Submission',
            'Correct Answer',
            'Result',
            'Marked'
        ];

        Swal.fire({
            title: 'File downloading',
            onOpen: function () {
                Swal.showLoading();
            },
        });

        // Helper function to strip HTML tags
        const stripHtml = (html) => {
            if (!html) return "-";
            try {
                const temp = document.createElement("div");
                temp.innerHTML = html;
                return temp.textContent || temp.innerText || "-";
            } catch (error) {
                console.error('Error stripping HTML:', error);
                return String(html || "-");
            }
        };

        data = data.map(row => {
            const newRow = {
                Student: row?.studentName || "-",
                Status: row?.status,
                Submission: stripHtml(row.UserAnswer),
                ['Correct Answer']: stripHtml(row.correctAnswer),
                Result: !isMatchingQuestionType(["Document Upload", "Evidence Only", "Long Answer"]) || (row?.score && row.is_marked) ? `${row?.score}/${row?.total_score}` : "-",
                Marked: row.is_marked || !isMatchingQuestionType(["Document Upload", "Evidence Only", "Long Answer"]) ? "MARKED" : "NOT MARKED",
            };

            // Remove fields based on question type
            if (isMatchingQuestionType(["Document upload", "Evidence Only"])) {
                delete newRow["Submission"];
                delete newRow["Correct Answer"];
            } else if (isMatchingQuestionType(["Long Answer"])) {
                delete newRow["Correct Answer"];
            }

            return newRow;
        });

        // Update header accordingly
        if (isMatchingQuestionType(["Document upload", "Evidence Only"])) {
            header = ['Student', 'Status', 'Result', 'Marked'];
        } else if (isMatchingQuestionType(["Long Answer"])) {
            header = ['Student', 'Status', 'Submission', 'Result', 'Marked'];
        }

        const pdfData = data.map(row => header.map(h => row[h] || "-"));

        Swal.close();

        return {
            header,
            data,
            pdfData,
            columnStyles: {},
        };
    });

    const toggleShowMore = (key) => {
        setExpanded(prev => ({
            ...prev,
            [key]: !prev[key],
        }));
    }

    return (
        <div className="assessment_marking">
            <div className="card-new card card-profile-info-card mb-30 mt-0 padding-20 " >
                {
                    questionDetailsLoading ? <SkeletonTicketList /> : (
                        <>
                            <div className="card-header" title="Question Name" >Question Name</div>
                            <div className="card-body-inr card-body-info" >
                                <div className="basic-info-box">
                                    <div className='d-flex flex-wrap justify-content-between '>

                                        {assessmentDetails?.map((detail, index) => {
                                            return (
                                                <div className="assessment-details-box flex flex-col" key={index} >
                                                    <h6 className="assessment-question-title " title={detail.tooltip}>{detail.title}:</h6>
                                                    <div className="d-flex flex-wrap ">
                                                        {detail?.value?.length > 0 ? detail?.value?.map((val, valIndex) => (
                                                            <div key={valIndex} className="flex items-center" title={val?.tooltip || ""}>
                                                                {val.icon && (
                                                                    <i
                                                                        className={`fal fa-${val.icon} assessment-question-icon`}
                                                                        style={{ color: val.color || 'currentColor' }}
                                                                    />
                                                                )}
                                                                {val.name && <span className="text-sm mr-2">{val.name}</span>}
                                                                {val?.render && val?.render}
                                                            </div>
                                                        )) : "-"}
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>

                            {questionData?.question && <div className={`assessement-question-desc description-container fontsize-16`}>
                                <h6 className="question-title font-size-14"> Question</h6>
                                {/* <h6 className="question-title font-size-14"> Match the column ACNH</h6> */}
                                <p
                                    ref={descriptionRef}
                                    className={`description-p ${expanded?.questionExpand ? 'expanded' : 'collapsed'} questionDescription font-size-14`}
                                    dangerouslySetInnerHTML={{ __html: questionData?.question }}
                                />

                                {showSeeMore?.questionExpandSeeMore && (
                                    <span onClick={() => toggleShowMore("questionExpand")} className="toggle-button">
                                        {expanded?.questionExpand ? 'See Less' : 'See More'}
                                    </span>
                                )}


                            </div>}
                            {!(isMatchingQuestionType(["Document Upload", "Long Answer", "Evidence Only"])) ?
                                <>
                                    <div className={`assessement-question-desc description-container fontsize-16`}>

                                        {questionData?.questionsOptions?.length ? <h6 className="question-title font-size-14"> Correct Answer</h6> : null}
                                        <div className={`match-column-con assessmentDisbale ${expanded?.questionAnswerExpand ? 'expanded' : 'collapsed'}`} ref={answersRef} >

                                            {
                                                isMatchingQuestionType(['Choice Matrix']) && questionData?.questionsOptions?.length ?
                                                    <RenderOption
                                                        selectedQ={"Choice Matrix"}
                                                        isOption={false}
                                                        extraClass={"assessment-marking-choice-matrix"}
                                                        choiceMatrixProps={
                                                            {
                                                                matrixArray: matrixData,
                                                            }
                                                        }
                                                        textCenterChoice={true}
                                                        headerExtraClass={'inputTextCenter'}
                                                    />
                                                    : null
                                            }
                                            {
                                                isMatchingQuestionType(['Order List']) ?
                                                    questionData?.questionsOptions?.map((question, id) => (
                                                        <div className='match-column-wrp'>
                                                            <span className='match-column-input correct-answer' attr={id} dangerouslySetInnerHTML={{ __html: question?.q_option }}></span>
                                                        </div>
                                                    )) : null
                                            }
                                            {
                                                isMatchingQuestionType(['Match the Column']) ? (
                                                    questionData?.questionsOptions
                                                        ?.map((answer) => (
                                                            <div className='match-column-wrp match-column'>
                                                                <span className={`match-column-input ${answer?.q_option?.length > 0 ? "" : "hide-border"}`}>{answer.q_option}</span>
                                                                <span className={`match-column-input ${answer?.q_option_match?.length > 0 ? "dashed" : "hide-border"} `}>{answer.q_option_match}</span>
                                                            </div>))) : null
                                            }
                                            {
                                                isMatchingQuestionType(['Multiple Choice Single Answer']) ?
                                                    <>
                                                        {
                                                            <div className="form-icon-group d-block">

                                                                {questionData?.questionsOptions?.map((item, i) => {
                                                                    return (
                                                                        <>

                                                                            <div className="">
                                                                                <input
                                                                                    type="radio"
                                                                                    className="cursor-pointer"
                                                                                    name="example"
                                                                                    checked={item.score}
                                                                                    readOnly
                                                                                />

                                                                                <label className="ml-2 cursor-pointer multiple-choice-label" htmlFor={`customRadio_`}>
                                                                                    {item.q_option ? HtmlParser(item.q_option) : ""}
                                                                                </label>

                                                                            </div>
                                                                        </>
                                                                    )
                                                                })}
                                                            </div>
                                                        }
                                                    </> : null
                                            }
                                            {
                                                isMatchingQuestionType(["Multiple Choice Multiple Answer"]) ?
                                                    <>
                                                        {
                                                            <div className="form-icon-group d-block">

                                                                {questionData?.questionsOptions?.map((item, i) => {
                                                                    return (
                                                                        <>

                                                                            <div className="">
                                                                                {/* que-custom-space */}
                                                                                <input
                                                                                    type="checkbox"
                                                                                    className="cursor-pointer"
                                                                                    name="example"
                                                                                    checked={item.score}
                                                                                    readOnly
                                                                                />

                                                                                <label className="ml-2 cursor-pointer multiple-choice-label" htmlFor={`customRadio_`}>
                                                                                    {item.q_option ? HtmlParser(item.q_option) : ""}
                                                                                </label>

                                                                            </div>
                                                                        </>
                                                                    )
                                                                })}
                                                            </div>
                                                        }
                                                    </> : null
                                            }
                                            {
                                                isMatchingQuestionType(['Fill in the blank', 'Short Answer']) ?
                                                    questionData?.questionsOptions?.map((question, id) => (
                                                        // <div className='match-column-wrp'>
                                                        <>
                                                            <span dangerouslySetInnerHTML={{ __html: question?.q_option?.replaceAll("~@~", ", ") }}></span>
                                                            {id !== questionData?.questionsOptions?.length - 1 ? ", " : ""}
                                                        </>

                                                    )) : null
                                            }
                                        </div>

                                        {showSeeMore?.questionAnswerExpandSeeMore && (
                                            <span onClick={() => toggleShowMore("questionAnswerExpand")} className="toggle-button">
                                                {expanded?.questionAnswerExpand ? 'See Less' : 'See More'}
                                            </span>
                                        )}
                                    </div>
                                </> : null}
                        </>
                    )
                }

            </div>


            <div className="my-tickets-info-list Tickets-main-wrap">

                {questionLoading ? <SkeletonTicketList /> : <DataTableComponentFrontPagination
                    tableTitle="Student List"
                    data={dataToRender}
                    columns={columns}
                    loading={questionLoading}
                    search={search}
                    setSearch={setSearch}
                    exportData={exportDataCallback}
                    exportFileName={"Assessment-Quiz-Test-Marking"}
                    defaultSort={{ defaultSortColumn: tableState.sortKey, defaultSortOrder: tableState.sortOrder === "asc" }}
                    filters={[
                        {
                            filterName: "Status",
                            optionArr: [
                                { label: "Appeal-Approved", value: "Appeal-Approved" },
                                { label: "Appeal-Pending", value: "Appeal-Pending" },
                                { label: "Draft", value: "DRAFT" },
                                { label: "Marked", value: "MARKED" },
                                { label: "Not Submitted", value: "NOT SUBMITTED" },
                                { label: "Submitted", value: "SUBMITTED" },
                                { label: "Closed-Not Submitted", value: "closednot submitted" },
                            ],
                            state: status,
                            setState: setStatus,
                            renderLabelFunction: RenderSubmissionStatus,
                        },
                        {
                            filterName: "Marked",
                            optionArr: [
                                { value: '1', label: "Marked" },
                                { value: '0', label: "Not Marked" }
                            ],
                            state: marked,
                            setState: setMarked,
                            renderLabelFunction: AssessmentMarkingMarkedFilter,
                        },
                    ]}
                    bottomButton={[
                        <>
                            {isMatchingQuestionType(["Document Upload"]) &&
                                dataToRender?.flatMap(i => i?.answerdDocument)?.length > 0 && (
                                    <div className="search-filter-div-right ml-0">
                                        <div className="filter-search-bar-blk">
                                            <div className="add-ticket-blk button-reset dropdown-comman">
                                                <DownloadModalComponent children={
                                                <button
                                                    type="button"
                                                    title='Download All Submissions'
                                                    className="btn btn-primary download-btn rm-box-shadow p-4"
                                                    data-toggle="modal" data-target="#downloadSubmissionAll"
                                                    // onClick={() => handleDownload("",assessmentName)}
                                                    
                                                >
                                                    <i className="fal fa-download"></i> Download All Submissions
                                                </button>
                                                } modalId={'downloadSubmissionAll'} type={'downloadSubmission'} payload={handleDownload("",assessmentName)} zipName={assessmentName} downloadRef={downloadRef}/>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                            {studentScore?.some((s) => s.error == true) ? <div className='invalid-feedback d-block mt-2'>{errorMessage}</div> : "" } 

                        </>
                    ]}
                />}
                <div ></div>

            </div>

            <div className='card-new card assessment-marking-question-box flex-column flex-md-row align-items-md-end align-items-start'>

                <div className='d-flex flex-column question-select-box' >
                    <label htmlFor="Question" >Question </label>
                    <div className="form-icon-group ">
                        <Select
                            className={`form-control custom-select-box `}
                            value={allQuestionList?.filter((question) => question?.value == questionId)?.[0]}
                            options={allQuestionList}
                            id="Question"
                            name="Question"
                            onChange={(selectedQuesiton) => {
                                if (selectedQuesiton?.value != questionId) {
                                    setQuestionLoading(true);
                                    setAllStudentList([])
                                    setQuestionData({});
                                    setStudentScore([])
                                    setDontShowLoading(false)
                                    setDontShowDetailsLoading(false)
                                    history.push(`${window.location.pathname}?questionId=${selectedQuesiton?.value}`)
                                }
                            }}
                            menuPlacement="top"
                            placeholder="Select Question"
                        />
                    </div>
                </div>

                <div className='btn-groups align-self-end'>
                    <button
                        className="btn btn-primary"
                        title="Question List"
                        onClick={goToQuestionList}
                    >
                        <i className="fal fa-clipboard-check"></i>Question List
                    </button>
                    <button
                        className="btn btn-primary"
                        title="Previous"
                        onClick={goToPreviousQuestion}
                        disabled={allQuestionList?.findIndex(q => q.value == questionId) <= 0}


                    >
                        <i className="fal fa-chevron-left"></i>Previous
                    </button>
                    <button
                        className="btn btn-primary"
                        title="Next"
                        onClick={goToNextQuestion}
                        disabled={allQuestionList?.findIndex(q => q.value == questionId) >= allQuestionList.length - 1}
                    >

                        Next <i className="fal fa-chevron-right"></i>
                    </button>
                </div>
            </div>
            
            <div className='assessment_marking'>
                <SubmissionModal
                    studentDetails={selectedStudentDetails}
                    assDetails={assDetails}
                    selectedStudentDetails={selectedStudentDetails}
                    setSelectedStudentDetails={setSelectedStudentDetails}
                    handleDownload={() => handleDownload(selectedStudentDetails?.uid, `${selectedStudentDetails?.first_name} ${selectedStudentDetails?.last_name}_${assessmentName}`)}
                    handleRefresh={() => {
                        setDontShowDetailsLoading(true)
                        setDontShowLoading(false)
                        setRefreshStudentList(!refreshStudentList)
                        setRefreshQuestiionData(!refreshQuestiionData)
                    }}
                    isMatchingQuestionType={isMatchingQuestionType}
                    questionData={questionData}
                    assessmentHeader={assessmentHeader}
                    tabName="Marked Question Student"
                    downloadRef={downloadRef}
                />
            </div>


         
        </div>


    )
}

export default AssessmentQuizTestMarking